import $ from 'jquery'
import 'magnific-popup'

export default function addGalleryModal() {
  function initiateGallery() {
    $('.c-content-gallery').each(function gallery() {
      // the containers for all your galleries
      $(this).magnificPopup({
        delegate: 'a', // the selector for gallery item
        type: 'image',
        gallery: {
          enabled: true,
          tCounter: '<span class="mfp-counter">%curr% / %total%</span>', // markup of counter,
          arrowMarkup:
            '<button title="%title%" type="button" class="c-gallery-arrow mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button
        },
      })
    })
  }

  const isPresent = document.getElementsByClassName('c-content-gallery')

  if (isPresent.length > 0) {
    $(document).ready(() => {
      initiateGallery()
    })
  }
}
